export const environment = {
  production: true,
  env: 'prod',
  tenantApiUrl: 'https://tenant.globalofficedatahub.com/',
  accountApiUrl: 'https://auth.globalofficedatahub.com/',
  frontendUrl: 'https://app.godatahub.com/',
  aiApiUrl: 'https://ai.prod0001.globalofficedatahub.com/',
  applicationApiUrl: undefined,
  authFrontendUrl: 'https://account.godatahub.com/'
};
